import { SERVICE } from './constants'

export const LOGOUT = `${SERVICE}/LOGOUT`

export const SET_USER = `${SERVICE}/SET_USER`
export const SET_TOKEN = `${SERVICE}/SET_TOKEN`
export const GET_STORED_TOKEN = `${SERVICE}/GET_STORED_TOKEN`
export const NEW_TOKEN = `${SERVICE}/NEW_TOKEN`

export const GET_USER_INFO = `${SERVICE}/GET_USER_INFO`

export const CHECK_ACTIVE_MODULE = `${SERVICE}/CHECK_ACTIVE_MODULE`
